const blue = {
  25: '#F8FAFC',
  50: '#EFF4FD',
  100: '#E0EAFE',
  150: '#D0DDFA',
  200: '#B1C7F7',
  300: '#92AEEC',
  400: '#7296E8',
  500: '#537BD5',
  600: '#2A5ED0',
  700: '#1449BE',
  800: '#0F3A9F',
  900: '#0D3082',
  950: '#031A6A',
};

const fuchsia = {
  50: '#FCEDF0',
  100: '#F7C9D5',
  200: '#F2A5BC',
  300: '#EE81A4',
  400: '#E95D8F',
  500: '#E5397C',
  600: '#E2016A',
  700: '#B80C59',
  800: '#8E0545',
  900: '#610130',
};

const purple = {
  100: '#EBE7F9',
  200: '#DCD3F3',
  300: '#C9B7EB',
  400: '#B799E1',
  500: '#A980D6',
  600: '#8A55AF',
  700: '#6F448D',
  800: '#52356B',
};

const yellow = {
  50: '#FFFBEE',
  100: '#FEF2D2',
  200: '#FFE5A0',
  300: '#FFD752',
  400: '#FFCD44',
  500: '#FFC01D',
  600: '#E5AC18',
  700: '#C88607',
  800: '#A06A18',
  900: '#794100',
};

const nude = {
  100: '#FFECEB',
  200: '#FFE3E1',
  300: '#FECDC9',
  400: '#EFB2AD',
  500: '#DE9790',
  600: '#CD7A74',
};

const green = {
  50: '#E0F6F6',
  100: '#CCEEED',
  200: '#A8DEDD',
  300: '#93D2D1',
  400: '#66BBB9',
  500: '#3AA5A3',
  600: '#0F8F8D',
  700: '#0C7271',
  800: '#095655',
  900: '#063938',
};

const red = {
  50: '#FFF1F0',
  100: '#FDD9DC',
  200: '#FFCCC7',
  300: '#FFA39E',
  400: '#FF7875',
  500: '#FF4D4F',
  600: '#F5222D',
  700: '#CF1322',
  800: '#A8071A',
  900: '#820014',
};

const gray = {
  50: '#F4F5F8',
  100: '#E4E6EB',
  200: '#D4D7DE',
  300: '#C3C7D1',
  400: '#B3B8C4',
  500: '#939AAB',
  600: '#727B91',
  700: '#525D77',
  800: '#40495F',
  900: '#28324A',
};

const fuchsiaDark = {
  50: '#FFD9E8',
  100: '#FFD9E8',
  150: '#FFABCC',
  200: '#FA84B2',
  300: '#FF619A',
  400: '#FC3C81',
  500: '#F72A7A',
  600: '#E71C7B',
  700: '#B80C59',
  800: '#8E0545',
  900: '#61002F',
};

const yellowDark = {
  50: '#FEF2D2',
  100: '#FFE5A0',
  200: '#FFD752',
  300: '#FFCD44',
  400: '#FFC01D',
  500: '#E5AC18',
  600: '#C69415',
  700: '#9A7928',
  800: '#78612A',
  900: '#66552B',
};

const infoBlueDark = {
  50: '#DAE4FB',
  100: '#C5D2EF',
  200: '#B1C0E3',
  300: '#9CAED7',
  400: '#889CCB',
  500: '#5F78B2',
  600: '#36549A',
  700: '#283E73',
  800: '#22345F',
  900: '#1B294C',
};

const grayDark = {
  200: '#383838',
  300: '#363636',
  400: '#333333',
  500: '#2E2E2E',
  600: '#2C2C2C',
  700: '#272727',
  800: '#232323',
  900: '#1E1E1E',
};

export const colors = {
  blue,
  fuchsia,
  purple,
  yellow,
  nude,
  green,
  red,
  gray,
  fuchsiaDark,
  yellowDark,
  infoBlueDark,
  grayDark,
};
